const SERVER_URL =
  "https://vivek-kakkad-backend-nodejs-895924407291.us-central1.run.app/";

const INSTAGRAM_KEY =
  "IGAAZAQjrz7cZCBBZAE56RjlOc2ZAyRFJWZAmVQeFV4ZAlZAJOGlUXzhIeWtiRkF6SnEzMWhwUHY2bm9OSHpPTXBqWVE1cVpzbFR4bEpOUVE2RW05NnlCNFJyYXBXdjg3R1NQVFBjLXQwaVBIdURVWHMyZAW5hOW42TWdBQTlnUVZAQSDhtcwZDZD";

module.exports = {
  SERVER_URL,
  INSTAGRAM_KEY,
};
